<template>
  <div>
    <Card style="width:100%;margin-bottom: 20px;">
      <p slot="title">
        <Icon type="md-person" size="22" style="margin-right:10px" />我的信息
      </p>
      <div>
        <Row>
          <Col :md="3" :xs="10" class="myinfoCol myinfoCol1">
            <router-link
              style="width:100%;display:contents"
              to="/95CAAAF222E7A036748785D9561E7187/A3FFBEBFDB713E27"
            >
              <img src="@/assets/indexImg0.jpg" />
              <div class="myinfoDate">
                出生日期
                <p>1986-06-02</p>
              </div>
            </router-link>
          </Col>

          <Col :md="7" :xs="24">
            <div class="cs-userInof-box">
              <div class="cs-userInof-item">
                <div class="label">姓名</div>
                <div class="val">{{ uerFormItem.name1 }}</div>
              </div>
              <div class="cs-userInof-item">
                <div class="label">工号</div>
                <div class="val">{{ uerFormItem.name2 }}</div>
              </div>
              <div class="cs-userInof-item">
                <div class="label">英文名</div>
                <div class="val">{{ uerFormItem.name3 }}</div>
              </div>
            </div>
          </Col>
          <Col :md="7" :xs="24">
            <div class="cs-userInof-box">
              <div class="cs-userInof-item">
                <div class="label">业务单元</div>
                <div class="val">{{ uerFormItem.name }}</div>
              </div>
              <div class="cs-userInof-item">
                <div class="label">部门</div>
                <div class="val">{{ uerFormItem.name }}</div>
              </div>
              <div class="cs-userInof-item">
                <div class="label">职能</div>
                <div class="val">{{ uerFormItem.name }}</div>
              </div>
            </div>
          </Col>
          <Col :md="7" :xs="24">
            <div class="cs-userInof-box">
              <div class="cs-userInof-item">
                <div class="label">直属领导</div>
                <div class="val">{{ uerFormItem.name }}</div>
              </div>
              <div class="cs-userInof-item">
                <div class="label">入职日期</div>
                <div class="val">{{ uerFormItem.name }}</div>
              </div>
              <div class="cs-userInof-item">
                <div class="label">Email</div>
                <div class="val">{{ uerFormItem.name }}</div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
    <Row>
      <Col :md="12" :xs="24">
        <div class="cs-progress-box">
          <div class="progressone">
            <div class="pieList">
              <div class="pieBox">
                <div class="pieColor" :class="current >= 0 ? 'pieColor1' : ''">目标设定
                </div>
              </div>
              <div class="arrowBox">
                <div
                  class="rectangle"
                  :class="current >= 0 ? 'rectangleColor1' : ''"
                ></div>
                <i class="arrow" :class="current >= 0 ? 'arrowColor1' : ''"></i>
              </div>
            </div>
            <div class="pieList">
              <div class="pieBox">
                <div class="pieColor" :class="current >= 3 ? 'pieColor2' : ''">
                  <!-- 阶段回顾 -->{{$t('Phase_Review')}}
                </div>
              </div>
              <div class="arrowBox">
                <div
                  class="rectangle"
                  :class="current >= 3 ? 'rectangleColor2' : ''"
                ></div>
                <i class="arrow" :class="current >= 3 ? 'arrowColor2' : ''"></i>
              </div>
            </div>
            <div class="pieList">
              <div class="pieBox">
                <div class="pieColor" :class="current >= 4 ? 'pieColor3' : ''">
                  年终总结
                </div>
              </div>
              <div class="arrowBox">
                <div
                  class="rectangle"
                  :class="current >= 4 ? 'rectangleColor3' : ''"
                ></div>
                <i class="arrow" :class="current >= 4 ? 'arrowColor3' : ''"></i>
              </div>
            </div>
            <div class="pieList">
              <div class="pieBox">
                <div class="pieColor" :class="current >= 8 ? 'pieColor4' : ''">
                  完成
                </div>
              </div>
            </div>
          </div>
          <div class="cs-progress-bottom">
            <div class="progresstwo">
              <div class="rectangleList">
                <div
                  class="rectangleBox"
                  :class="current >= 0 ? 'rectangleBoxColor1' : ''"
                >
                  目标设定
                </div>
              </div>
              <div class="rectangleArrow" v-if="current < 0">
                <Icon
                  type="md-arrow-round-forward"
                  size="30"
                  style="color:rgb(37, 131, 255)"
                />
              </div>
              <div class="arrowBox" v-if="current == 0">
                <i class="arrow arrowColor1"></i>
              </div>
              <div class="rectangleList">
                <div
                  class="rectangleBox"
                  :class="current >= 1 ? 'rectangleBoxColor2' : ''"
                >
                  <Icon type="ios-text" /> 审批完成
                </div>
              </div>
              <div class="rectangleArrow" v-if="current < 1">
                <Icon
                  type="md-arrow-round-forward"
                  size="30"
                  style="color:rgb(37, 131, 255)"
                />
              </div>
              <div class="arrowBox" v-if="current == 1">
                <i class="arrow arrowColor2"></i>
              </div>
              <div class="rectangleList">
                <div
                  class="rectangleBox"
                  :class="current >= 2 ? 'rectangleBoxColor3' : ''"
                >
                  目标修订
                </div>
              </div>
            </div>
            <div class="progresstwo">
              <div class="rectangleList">
                <div
                  class="rectangleBox"
                  :class="current >= 3 ? 'rectangleBoxColor1' : ''"
                >
                  填写回顾
                </div>
              </div>
            </div>
            <div class="progresstwo">
              <div class="rectangleList">
                <div
                  class="rectangleBox"
                  :class="current >= 4 ? 'rectangleBoxColor1' : ''"
                >
                  员工自评
                </div>
              </div>
              <div class="rectangleArrow" v-if="current < 4">
                <Icon
                  type="md-arrow-round-forward"
                  size="30"
                  style="color:rgb(37, 131, 255)"
                />
              </div>
              <div class="arrowBox" v-if="current == 4">
                <i class="arrow arrowColor1"></i>
              </div>
              <div class="rectangleList">
                <div
                  class="rectangleBox"
                  :class="current >= 5 ? 'rectangleBoxColor2' : ''"
                >
                  经理初评
                </div>
              </div>
              <div class="rectangleArrow" v-if="current < 5">
                <Icon
                  type="md-arrow-round-forward"
                  size="30"
                  style="color:rgb(37, 131, 255)"
                />
              </div>
              <div class="arrowBox" v-if="current == 5">
                <i class="arrow arrowColor2"></i>
              </div>
              <div class="rectangleList">
                <div
                  class="rectangleBox"
                  :class="current >= 6 ? 'rectangleBoxColor3' : ''"
                >
                  人才评估会议
                </div>
              </div>
              <div class="rectangleArrow" v-if="current < 6">
                <Icon
                  type="md-arrow-round-forward"
                  size="30"
                  style="color:rgb(37, 131, 255)"
                />
              </div>
              <div class="arrowBox" v-if="current == 6">
                <i class="arrow arrowColor3"></i>
              </div>
              <div class="rectangleList">
                <div
                  class="rectangleBox"
                  :class="current >= 7 ? 'rectangleBoxColor1' : ''"
                >
                  绩效面谈
                </div>
              </div>
              <div class="rectangleArrow" v-if="current < 7">
                <Icon
                  type="md-arrow-round-forward"
                  size="30"
                  style="color:rgb(37, 131, 255)"
                />
              </div>
              <div class="arrowBox" v-if="current == 7">
                <i class="arrow arrowColor1"></i>
              </div>
              <div class="rectangleList">
                <div
                  class="rectangleBox"
                  :class="current >= 8 ? 'rectangleBoxColor2' : ''"
                >
                  员工确认
                </div>
              </div>
            </div>
          </div>
        </div>
        <Button type="primary" @click="next">下一步</Button>
      </Col>
      <Col :md="12" :xs="24">
        <Card style="width:100%;margin-bottom: 20px;">
          <p slot="title" style="height: 35px;">
            年度
            <DatePicker
              type="year"
              v-model="uerFormItem.begindate"
            ></DatePicker>
          </p>
          <template #extra>
            <div
              class="headerTextStyle"
              href="#"
              @click="
                goPage('/E01D53781C5C6CF3BA610C6A6F738319/A3FFBEBFDB713E27')
              "
            >
              详情
              <Icon type="ios-arrow-forward" />
            </div>
          </template>
          <Row>
            <Col :md="12" :xs="24">
              <div class="cs-userInof-box">
                <div class="cs-userInof-item">
                  <div class="label">员工姓名</div>
                  <div class="val">{{ uerFormItem.name1 }}</div>
                </div>
                <div class="cs-userInof-item">
                  <div class="label">员工号</div>
                  <div class="val">{{ uerFormItem.name2 }}</div>
                </div>
                <div class="cs-userInof-item">
                  <div class="label">业务单元</div>
                  <div class="val">{{ uerFormItem.name3 }}</div>
                </div>
              </div>
            </Col>
            <Col :md="12" :xs="24">
              <div class="cs-userInof-box">
                <div class="cs-userInof-item">
                  <div class="label">职位</div>
                  <div class="val">{{ uerFormItem.name }}</div>
                </div>
                <div class="cs-userInof-item">
                  <div class="label">部门</div>
                  <div class="val">{{ uerFormItem.name }}</div>
                </div>
                <div class="cs-userInof-item">
                  <div class="label">年度</div>
                  <div class="val">{{ uerFormItem.name }}</div>
                </div>
              </div>
            </Col>
            <Col :md="12" :xs="24">
              <div class="cs-userInof-box">
                <div class="cs-userInof-item">
                  <div class="label">直接主管</div>
                  <div class="val">{{ uerFormItem.name }}</div>
                </div>
                <div class="cs-userInof-item">
                  <div class="label">版本</div>
                  <div class="val">{{ uerFormItem.name }}</div>
                </div>
                <div class="cs-userInof-item">
                  <div class="label">状态</div>
                  <div class="val">{{ uerFormItem.name }}</div>
                </div>
              </div>
            </Col>
          </Row>
        </Card>
        <!-- <Form :model="formItem" :label-width="120">
          <FormItem label="年度">
            <Select v-model="formItem.code1" style="width:200px">
              <Option
                v-for="item in list"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Form>
        <Table border :columns="columns" :data="columnsData">
          <template slot-scope="{ row, index }" slot="action">
            <Icon size="44" color="#8CD29B" type="md-menu" />
          </template>
        </Table> -->
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uerFormItem: {
        name: 123,
        name1: "陈朴达",
        name2: "PL0038",
        name3: "Chen"
      },
      current: 0,
      current: 0,
      formItem: {},
      list: [],
      columns: [
        {
          title: "员工姓名",
          key: "applyNo",
          align: "center",
          minWidth: 200
        },
        {
          title: "员工号",
          key: "applyNo",
          align: "center",
          minWidth: 200
        },
        {
          title: "业务单元",
          key: "applyNo",
          align: "center",
          minWidth: 200
        },
        {
          title: "职位",
          key: "applyNo",
          align: "center",
          minWidth: 200
        },
        {
          title: "部门",
          key: "applyNo",
          align: "center",
          minWidth: 200
        },
        {
          title: "年度",
          key: "applyNo",
          align: "center",
          minWidth: 200
        },
        {
          title: "直接主管",
          key: "applyNo",
          align: "center",
          minWidth: 200
        },
        {
          title: "版本",
          key: "applyNo",
          align: "center",
          minWidth: 200
        },
        {
          title: "状态",
          key: "applyNo",
          align: "center",
          minWidth: 200
        },
        {
          title: "查看",
          slot: "action",
          minWidth: 80
        }
      ],
      columnsData: [{}]
    };
  },
  methods: {
    next() {
      if (this.current == 8) {
        this.current = 0;
      } else {
        this.current += 1;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.headerTextStyle {
  cursor: pointer;
}
.cs-userInof-box {
  padding: 10px;
}
.myinfoCol1 ~ .ivu-col .cs-userInof-box {
  padding: 20px;
}

.cs-userInof-item {
  line-height: 50px;
  padding: 0 10px;
  width: 100%;
  display: flex;
  border-bottom: 1px solid #018040;
  justify-content: space-between;
  .label {
    flex: 1;
  }
  .val {
    flex: 3;
    text-align: center;
    font-size: 16px;
  }
}
.myinfoCol1 + .ivu-col .cs-userInof-box .cs-userInof-item {
  border-bottom-color: #018040;
}
.myinfoCol1 {
  position: relative;
  padding: 0;
  width: 150px;
  img {
    max-width: 100%;
    max-height: 200px;
    border-radius: 8px;
  }
  .myinfoDate {
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: 50px;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.4);
    padding: 5px;
    box-sizing: border-box;
    border-radius: 0 0 8px 8px;
  }
}
.cs-progress-box {
  padding: 20px;
  padding-top: 0;
  display: flex;
  overflow: auto;
}
.cs-progress-box ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.progressone {
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .pieList {
    display: flex;
    flex-direction: column;
    align-items: center;
    .pieBox {
      height: 100px;
      border-radius: 50%;
      background-color: #dfdfdf;
      flex-direction: column;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 5px 5px #8a8a8a;
      border: 3px solid #eee;
      .pieColor {
        color: #ffffff;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
      }
      .pieColor1 {
        background-color: #76a42d;
        box-shadow: 0px 0px 5px #76a42d;
      }
      .pieColor2 {
        background-color: #ef881a;
        box-shadow: 0px 0px 5px #ef881a;
      }
      .pieColor3 {
        background-color: #20a0d5;
        box-shadow: 0px 0px 5px #20a0d5;
      }
      .pieColor4 {
        background-color: #8f7eb9;
        box-shadow: 0px 0px 5px #8f7eb9;
      }
    }
    .arrowBox {
      position: relative;
      display: flex;
      align-items: center;
      .rectangle {
        width: 30px;
        height: 38px;
        background-color: #dfdfdf;
        margin-top: 5px;
      }
      .rectangleColor1 {
        background-color: #76a42d;
      }
      .rectangleColor2 {
        background-color: #ef881a;
      }
      .rectangleColor3 {
        background-color: #20a0d5;
      }

      .arrow {
        width: 0;
        height: 0;
        display: none;
        position: absolute;
        right: 0;
        bottom: -10px;
        border-bottom: 10px transparent dashed;
        border-right: 10px transparent dashed;
        border-left: 10px transparent solid;
        overflow: hidden;
      }
      .arrowColor1 {
        border-top: 10px #76a42d solid;
      }
      .arrowColor2 {
        border-top: 10px #f1891a solid;
      }
      .arrowColor3 {
        border-top: 10px #20a0d5 solid;
      }
    }
  }
}
// .progressone > .pieList:nth-of-type(1) .arrowBox {
//   height: 100px;
//   .rectangle {
//     height: 80px;
//   }
// }
// .progressone > .pieList:nth-of-type(2) .arrowBox {
//   height: 100px;
//   .rectangle {
//     height: 80px;
//   }
// }
// .progressone > .pieList:nth-of-type(3) .arrowBox {
//   height: 420px;
//   .rectangle {
//     height: 400px;
//   }
// }
.cs-progress-bottom {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  height: 370px;
  justify-content: space-between;
}
.progresstwo {
  display: flex;
  padding: 20px;
  .rectangleList {
    display: flex;

    .rectangleBox {
      width: 110px;
      height: 40px;
      background-color: #cecdcd;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .rectangleBoxColor1 {
      background-color: #20a0d5;
      color: #fafafa;
    }
    .rectangleBoxColor2 {
      background-color: #76a42d;
      color: #fafafa;
    }
    .rectangleBoxColor3 {
      background-color: #f1891a;
      color: #fafafa;
    }
    .rectangleBoxColor4 {
      background-color: #8f7eb9;
      color: #fafafa;
    }
  }
  .rectangleArrow {
    width: 25px;
    padding: 5px;
    height: 40px;
    background-color: #cecdcd;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .arrowBox {
    position: relative;
    width: 10px;
    background-color: #cecdcd;
    .arrow {
      width: 0;
      height: 0;
      display: block;
      position: absolute;
      left: 0;
      top: 10px;
      border-top: 10px transparent dashed;
      border-right: 10px transparent dashed;
      border-bottom: 10px transparent dashed;
      border-left: 10px #dfdfdf solid;
      overflow: hidden;
      border-left: 10px #dfdfdf solid;
    }
    .arrowColor1 {
      border-left: 10px #20a0d5 solid;
    }
    .arrowColor2 {
      border-left: 10px #76a42d solid;
    }
    .arrowColor3 {
      border-left: 10px #f1891a solid;
    }
  }
  .rectangleArrow + .rectangleList .rectangleBox {
    width: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bipage/components/ProgressComponent.vue